import { theme } from '../globalStyle/global-styles';
import styled from 'styled-components';

export const SearchWrapper = styled.div`
  width: 100%;
  @media (max-width: 767px) {
    width: 100%;
  }

  .search_wrappeer {
    padding: 0;
    border-radius: 8px;
    background-color: ${theme.colours.white};
    .mantine-Input-rightSection {
      &:lang(ar) {
        left: 0;
        right: initial;
      }
      &:lang(en) {
        right: 0;
        left: initial;
      }
      cursor: pointer;
    }
    .mantine-Autocomplete-icon {
      &:lang(en) {
        right: 0;
        left: initial;
      }
    }
    input {
      font-family: ${theme.fonts.Medium};
      border: 0.5px solid ${theme.colours.newOutline};
      width: 100%;
      border-radius: 8px;
      height: 28px !important;
      min-height: 28px !important;

      &:lang(ar) {
        padding-right: 35px !important;
        padding-left: 20px;
      }

      &:lang(en) {
        padding-left: 35px !important;
        padding-right: 0;
        @media (max-width: 767px) {
          padding-left: 0 !important;
        }
      }
      text-align: right;
      ::placeholder {
        color: ${theme.colours.gray5};
        font-size: 14px;
        line-height: 20px;
      }
      @media (max-width: 767px) {
        width: 100%;
      }
    }
    svg {
      &.active {
        cursor: pointer;
        pointer-events: auto;
        path {
          fill: ${theme.colours.blackText};
        }
      }
    }
  }
`;
